/** @format */

export enum RewardsServiceErrorLogKeys {
	REWARDS_SERVICE_GET_OFFERS = 'REWARDS_SERVICE_GET_OFFERS_ERROR',
	REWARDS_SERVICE_GET_REWARDS = 'REWARDS_SERVICE_GET_REWARDS_ERROR'
}
